import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../css/wishlist.css";
import { useDispatch, useSelector } from "react-redux";
// import { toast } from "react-toastify";
import toast from "react-hot-toast";
import { AddToCartModal } from "../component/AddToCartModal";
import BASE_URL from "../api/config";
import axios from "axios";
import {
  AddToWishlist,
  WishlistCounter,
  wishlistId,
} from "../redux/wishlistSlice";
import { AddToCart, CartTotal } from "../redux/cartSlice";
import useValidateUser from "../component/useValidateUser";
import Loader2 from "../component/Loader2";

const Wishlist = () => {
  const navigate = useNavigate();
  const [showVariationModal, setShowVariationModal] = useState(false);
  const [selectedProductForModal, setSelectedProductForModal] = useState(null);
  const token = useSelector((state) => state.auth.token);
  // const [token] = useState(JSON.parse(localStorage.getItem("auth_token")));
  const wishlistData = useSelector((state) => state?.wishlist?.wishlist);
  const Loading = useSelector((state) => state.wishlist?.loading);
  const cartData = useSelector((state) => state.cart?.cart);
  const dispatch = useDispatch();
  const [loading, setloading] = useState(true);
  const [apiLoading, setApiLoading] = useState(false);
  const validateUser = useValidateUser();

  const wishlistId1 = useSelector((state) => state.wishlist?.wishlistId);

  const handledeleteWishlist = async (filterwishlist, wishlistid, product) => {
    // console.log("deletewishlist", filterwishlist, wishlistId1, [
    //   ...wishlistId1,
    //   product?.product_id,
    // ]);
    // const updatedWishlist = wishlistId1.filter(id => id !== product?.product_id);
    // const filterData = wishlistData.filter((i)=>i.product_id !== product?.product_id)
    // console.log("updatewish",updatedWishlist,"filterData",filterData);
    setApiLoading(true);
    await axios
      .post(
        `${BASE_URL}/delete-wishlist`,
        { wishlist_id: filterwishlist[0]?.wishlist_id },
        {
          headers: {
            Authorization: `Bearer ${token}`.replace(/\s+/g, " ").trim(),
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        // console.log("res", res.data);
        const updatedWishlist = wishlistId1.filter(
          (id) => id !== product?.product_id
        );
        const filterData = wishlistData.filter(
          (i) => i.product_id !== product?.product_id
        );
        setApiLoading(false);
        dispatch(AddToWishlist(filterData));
        dispatch(wishlistId(updatedWishlist));
        dispatch(WishlistCounter(res?.data?.wishlist_count));
      })
      .catch((err) => console.log("err", err));
  };
  const handleDeleteWishlist = async (e, product) => {
    const a = wishlistData?.filter((i) => i.product_id === product?.product_id);

    // console.log("delte", a);
    setApiLoading(true);
    await axios
      .post(
        `${BASE_URL}/delete-wishlist`,
        { wishlist_id: a[0]?.wishlist_id },
        {
          headers: {
            Authorization: `Bearer ${token}`.replace(/\s+/g, " ").trim(),
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        console.log("res", res.data);
        const updatedWishlist = wishlistId1.filter(
          (id) => id !== product?.product_id
        );
        const filterData = wishlistData?.filter(
          (i) => i.product_id !== product?.product_id
        );
        window.scrollTo({ top: 0, behavior: "smooth" });
        setApiLoading(false);
        dispatch(AddToWishlist(filterData));
        dispatch(wishlistId(updatedWishlist));
        dispatch(WishlistCounter(res?.data?.wishlist_count));
      })
      .catch((err) => console.log("err", err));
  };
  const handleAddToCart = async (e, product, selectedAttributes, qty) => {
    // console.log("handleAddtoCart", e, product, selectedAttributes, qty);
    if (token === "null" || !token) {
      validateUser();
      toast.error("Please login to product add to cart!");
    } else {
      // console.log("addtoCart",product,"cartData",cartData);
      const filterwishlist = wishlistData?.filter(
        (i) => i?.product_id === product?.product_id
      );

      const filterwishlistId = wishlistId1.includes(product?.product_id);
      // console.log("fil",filterwishlistId,wishlistId1)
      const AlreadyExistsData = cartData?.items.filter((i) => {
        const sizeMatch =
          i?.variation_id !== 0
            ? i?.variation_id === selectedAttributes?.id
            : true && i?.product_id === product?.product_id;
        return sizeMatch;
      });
      // console.log(
      //   "AlreasyExistData",
      //   AlreadyExistsData,
      //   "quantity",
      //   qty,
      //   "selectAttributes",
      //   selectedAttributes
      // );
      if (product?.id !== 4070) {
        if (AlreadyExistsData.length > 0) {
          if (
            product?.variations &&
            product?.variations.length !== 0 &&
            selectedAttributes === 0
          ) {
            // console.log("call addtocart api");
            setShowVariationModal((prev) => !prev);
            setSelectedProductForModal(product);
          } else {
            if (
              selectedAttributes === null &&
              selectedAttributes !== undefined
            ) {
              toast.error(
                `please select ${product?.variations?.map(
                  (i, index) => Object.keys(i?.attributes)[index]
                )[0]
                }`
              );
            } else {
              if (selectedAttributes === undefined) {
                toast.error(
                  `please select ${product?.variations?.map(
                    (i, index) => Object.keys(i?.attributes)[index]
                  )[1]
                  }`
                );
              } else {
                if (selectedAttributes?.stock !== "outofstock") {
                  // const payload = {
                  //   cart_id: AlreadyExistsData[0]?.cart_id,
                  //   quantity: AlreadyExistsData[0]?.quantity + qty,
                  // };
                  handledeleteWishlist(
                    filterwishlist,
                    filterwishlistId,
                    product
                  );
                  const payload = {
                    cart_id: AlreadyExistsData[0]?.cart_id,
                    quantity: AlreadyExistsData[0]?.quantity + qty,
                  };
                  setApiLoading(true);
                  await axios
                    .post(`${BASE_URL}/update-cart`, payload, {
                      headers: {
                        Authorization: `Bearer ${token}`
                          .replace(/\s+/g, " ")
                          .trim(),
                        "Content-Type": "application/json",
                      },
                    })
                    .then((res) => {
                      // setApiLoading(false);
                      if (showVariationModal === true) {
                        setShowVariationModal((prev) => !prev);
                      }
                      toast.success("Product updated in cart successfully!");
                      dispatch(
                        AddToCart({ ...res.data, items: res.data.items })
                      );
                    })
                    .catch((err) => {
                      console.log("error", err);
                    });
                  console.warn("Edit CartData api call", filterwishlist);
                } else {
                  toast.error(`${product?.name} is outofstock`);
                }
              }
            }
          }
        } else {
          if (
            product?.variations &&
            product?.variations.length !== 0 &&
            selectedAttributes === 0
          ) {
            // console.log("call addtocart api");
            setShowVariationModal((prev) => !prev);
            setSelectedProductForModal(product);
          } else {
            if (
              selectedAttributes === null &&
              selectedAttributes !== undefined
            ) {
              toast.error(
                `please select ${product?.variations?.map(
                  (i, index) => Object.keys(i?.attributes)[index]
                )[0]
                }`
              );
            } else {
              if (selectedAttributes === undefined) {
                toast.error(
                  `please select ${product?.variations?.map(
                    (i, index) => Object.keys(i?.attributes)[index]
                  )[1]
                  }`
                );
              } else {
                if (selectedAttributes?.stock !== "outofstock") {
                  handledeleteWishlist(
                    filterwishlist,
                    filterwishlistId,
                    product
                  );
                  const payload = {
                    product_id: product?.product_id,
                    variation_id:
                      selectedAttributes === 0
                        ? selectedAttributes
                        : selectedAttributes?.id,
                    quantity: qty,
                  };
                  // console.log("paylaod", payload, "selecy", selectedAttributes);
                  await axios
                    .post(`${BASE_URL}/new-add-to-cart`, payload, {
                      headers: {
                        Authorization: `Bearer ${token}`.replace(/\s+/g, " ").trim(),
                        "Content-Type": "application/json",
                      },
                    })
                    .then((res) => {
                      console.log("res", res.data);
                      if (showVariationModal === true) {
                        setShowVariationModal((prev) => !prev);
                      }
                      toast.success("Product added to cart successfully!");
                      dispatch(CartTotal(res.data.cart_total));
                      // dispatch(CartCounter(res.data.cart_count));
                      dispatch(
                        AddToCart({
                          ...res.data,
                          items: [...cartData.items, res.data?.data],
                        })
                      );
                    })
                    .catch((err) => console.log("error", err));
                  console.warn("Add CartData api call");
                } else {
                  toast.error(`${product?.name} is outofstock`);
                }
              }
            }
          }
        }
      }
    }
  };
  const handleCardModalError = () => { };

  useEffect(() => {
    // 1. Agar token missing hai toh redirect aur login prompt
    if (!token || token === "null") {
      // User ko pichle page par wapas bhej raha hai
      // Agar pichla page nahi hai toh ye home page par le jayega
      navigate(-1);

      // Login dialog open karne ke liye hook trigger karein
      validateUser();

      // Yahan toast dikhana chahein toh dikha sakte hain
      toast.error("Please login to access your wishlist!");
      return; // Aage ka code execute na ho isliye return
    }

    // 2. Agar token hai, toh baki logic chalne dein
    window.scrollTo({ top: 0, behavior: "smooth" });

    const timer = setTimeout(() => {
      setloading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [token, navigate, validateUser]);

  // ... baki component logic same rahega
  return (
    <div className="home-main pt-0">
      <section className="Breadcrumbs-section">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item ">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">
                <Link to="/wishlist">WishList</Link>
              </li>
            </ol>
          </nav>
        </div>
      </section>
      {apiLoading && <Loader2></Loader2>}
      {loading || Loading ? (
        <Loader2></Loader2>
      ) : (
        <>
          {wishlistData?.length === 0 ? (
            <div className="my-5 text-center wishlist-page-empty">
              <p className="mb-3">Your Wishlist Is Empty!</p>
              <Link to="/products" className="mb-2">
                Shop Now
              </Link>
            </div>
          ) : (
            <>
              <section className="wishlist-section">
                <AddToCartModal
                  isOpen={showVariationModal}
                  onClose={() => setShowVariationModal(false)}
                  product={selectedProductForModal}
                  onAddToCart={handleAddToCart}
                  variations={selectedProductForModal?.variation}
                  handleCardModalError={handleCardModalError}
                ></AddToCartModal>
                <div className="container">
                  <div className="wishlist-container my-4">
                    <div className="wishlist-header">
                      <h2>Img</h2>
                      <h2>Product</h2>
                      <h2>Price</h2>
                      <h2>Pack Size</h2>
                      <h2>Stock</h2>
                      <h2>Cart</h2>
                    </div>
                    {wishlistData?.map((item, index) => {
                      console.log("ietm", item);
                      return (
                        <React.Fragment key={index}>
                          <div className="wishlist-item " key={index}>
                            <div className="wishlist-item-wrapper ">
                              {/* h-100 d-flex flex-column */}
                              <div className="wishlist-item-product">
                                <img
                                  src={item?.image}
                                  alt="wishlist-product-img"
                                  width={145}
                                  height={200}
                                  className="wishlist-product-img img-fluid"
                                ></img>
                              </div>

                              <div
                                className="d-flex flex-column align-item-stretch h-100 d-md-none"
                                style={{ flex: 1 }}
                              >
                                <p className="wishlist-item-name mb-1 d-md-none">
                                  {item?.name}
                                </p>
                                <p className="wishlist-item-price mb-md-0 mb-1 d-md-none">
                                  ₹{Number(item?.price).toFixed(2)}
                                </p>
                                <p className="wishlist-item-pack mb-md-0 mb-4 d-md-none">
                                  {item?.short_description}
                                </p>
                              </div>
                            </div>
                            <p className="wishlist-item-name mb-1 d-md-block d-none">
                              {item?.name}
                            </p>
                            <p className="wishlist-item-price mb-md-0 mb-1 d-md-block d-none">
                              ₹{Number(item?.price).toFixed(2)}
                            </p>
                            <p className="wishlist-item-pack mb-md-0 mb-4 d-md-block d-none">
                              {item?.short_description}
                              {/* {item?.short_description?.replace(/<\/?(ul|li)[^>]*>/g, "")} */}
                            </p>
                            <button
                              className={`btn wishlist-item-stock ${item.stock}`}
                            >
                              {item?.stock}
                            </button>
                            <button
                              className={`btn wishlist-addTocart ${item.stock}`}
                              onClick={(e) =>
                                item.stock === "instock" ? (
                                  handleAddToCart(e, item, 0, 1)
                                ) : (
                                  <></>
                                )
                              }
                            >
                              <span className="d-md-none d-lg-block">
                                Add to Cart
                              </span>
                              <img
                                className="d-md-flex justify-content-center m-auto d-lg-none d-none img-fluid"
                                alt="cart-icon"
                                src="/img/cart-icon.svg"
                                width="25"
                                height="25"
                              ></img>
                            </button>
                            <button
                              className="wishlist-item-remove"
                              onClick={(e) => handleDeleteWishlist(e, item)}
                            >
                              ✕
                            </button>
                          </div>
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>
              </section>
            </>
          )}
        </>
      )}
    </div>
  );
};
export default Wishlist;
